export default "assets/logo-0a5926c9.svg";